// BFSInteractivePage.jsx
import React from 'react';
import { Typography, Paper } from '@mui/material';
import Grid from '@mui/material/Grid';
import BFSLearningTool from './BFSLearningTool';

function BFSInteractivePage() {
  return (
    <section style={{ padding: '20px' }}>
      <Typography variant="h4" gutterBottom>
        BFS Interactive
      </Typography>
      <Typography variant="body1" paragraph>
        This interactive lets you play the role of the BFS algorithm: dequeue nodes,
        pick unvisited neighbors, and watch the queue and exploration order evolve. This interactive comes from
          Gemini3.
      </Typography>

      <Grid container justifyContent="center">
        <Grid item xs={12} md={10}>
          <Paper style={{ padding: '16px' }}>
            <BFSLearningTool />
          </Paper>
        </Grid>
      </Grid>
    </section>
  );
}

export default BFSInteractivePage;
